import { Button, Dropdown, Tooltip } from 'antd';
import {
  UserAddOutlined,
  CheckSquareOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { MenuProps } from 'antd';

export function QuickActions() {
  const { t } = useTranslation(['translation', 'menu']);
  const navigate = useNavigate();

  const quickActionItems: MenuProps['items'] = [
    {
      key: 'create-customer',
      icon: <UserAddOutlined />,
      label: t('menu:customers_create'),
      onClick: () => navigate('/customers/create'),
    },
    {
      key: 'create-task',
      icon: <CheckSquareOutlined />,
      label: t('menu:tasks_create'),
      onClick: () => navigate('/tasks/create'),
    },
    {
      type: 'divider',
    },
    {
      key: 'customer-list',
      label: t('menu:customers_list'),
      onClick: () => navigate('/customers'),
    },
    {
      key: 'task-list',
      label: t('menu:tasks_list'),
      onClick: () => navigate('/tasks'),
    },
  ];

  return (
    <Dropdown menu={{ items: quickActionItems }} trigger={['click']}>
      <Tooltip title={t('appHeader.quickActions.title')}>
        <Button
          type="primary"
          aria-label={t('common.create')}
          icon={<ThunderboltOutlined aria-hidden />}
          size="large"
          style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            border: 'none',
          }}
        >
          {t('common.create')}
        </Button>
      </Tooltip>
    </Dropdown>
  );
}
